export const CUSTOMER_TYPE = {
  USER: 'user',
  ORGANIZATION: 'organization',
} as const

export const PAYMENT_TYPE = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  CUSTOM: 'custom',
} as const

export enum IndividualType {
  INTERN = 'intern',
  DOCTOR = 'doctor',
  ADHERENT = 'adherent',
}

export enum RppsFunction {
  INTERN = 'interne',
}

export const PASSWORD_VALIDATION = {
  MIN_LENGTH: 8,
  REQUIRE_UPPERCASE: /[A-Z]/,
  REQUIRE_NUMBER: /[0-9]/,
} as const
